
































































































import Vue from 'vue'
import { getNestedValue } from '@/util/helpers'
import { TransactionMap } from '@/components/gmap/'
import { DataTableHeader } from 'vuetify/types'

interface DataOptions {
  loading: boolean
  page: number
  pageCount: number
  itemsPerPage: number
  headers: DataTableHeader[]
  editedRows: { [id: number]: boolean }
  editedCoefficients: { [id: number]: number }
}

export default Vue.extend({
  data(): DataOptions {
    return {
      loading: false,
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      headers: [
        {
          text: 'Jednotka',
          value: 'unitCode',
          sortable: false,
        },
        {
          text: 'Projekt',
          value: 'projectName',
          sortable: false,
        },
        {
          text: 'NP',
          value: 'floorDesc',
          sortable: false,
        },
        {
          text: 'Z skóre',
          value: 'ZScore',
          sortable: false,
          align: 'center',
        },
        {
          text: 'Dispozice',
          value: 'apartmentLayout',
          sortable: false,
          align: 'center',
        },
        {
          text: 'Plocha jednotky',
          value: 'unitArea',
          sortable: false,
          align: 'center',
        },
        {
          text: 'Plocha balkonu',
          value: 'unitAreaBalcony',
          sortable: false,
          align: 'center',
        },
        {
          text: 'Plocha lodžie',
          value: 'unitAreaLoggie',
          sortable: false,
          align: 'center',
        },
        {
          text: 'Plocha terasy',
          value: 'unitAreaTerrace',
          sortable: false,
          align: 'center',
        },
        {
          text: 'Plocha pozemku',
          value: 'unitAreaGround',
          sortable: false,
          align: 'center',
        },
        {
          text: 'Plocha sklepa',
          value: 'unitAreaC',
          sortable: false,
          align: 'center',
        },
        {
          text: 'Ceníková cena jednotky',
          value: 'priceTotal',
          sortable: false,
        },
        {
          text: 'Stav',
          value: 'poSellStatus5Desc',
          sortable: false,
          align: 'center',
        },
        {
          text: 'Vzdálenost od posuzované nemovitosti',
          value: 'distance',
          sortable: false,
          width: 50,
          align: 'center',
        },
        {
          text: 'SOZ/NOZ',
          value: 'civilCode',
          sortable: false,
          align: 'center',
        },
        {
          text: 'Koeficient supervize',
          value: 'priceCoefficient',
          sortable: false,
        },
        {
          text: '',
          value: 'action',
          sortable: false,
          align: 'center',
        },
      ],
      editedRows: {},
      editedCoefficients: {},
    }
  },
  computed: {
    transactions(): any[] {
      return getNestedValue(
        this.$store.getters['valuationEdit/data'],
        ['transactionData', 'offeredTransactions', 'transactions'],
        []
      )
    },
    transactionsCount(): number {
      return getNestedValue(
        this.$store.getters['valuationEdit/data'],
        ['transactionData', 'offeredTransactions', 'transactionsCnt'],
        0
      )
    },
    mapData(): any[] {
      return getNestedValue(
        this.$store.getters['valuationEdit/data'],
        ['transactionData', 'offeredTransactions', 'mapData'],
        []
      )
    },
    centerPosition(): { lat: number; lng: number } {
      return {
        lat: getNestedValue(this.mapData, [0, 'lat'], 50),
        lng: getNestedValue(this.mapData, [0, 'lng'], 50),
      }
    },
  },
  methods: {
    toggleTransaction(item: any) {
      if (this.editedRows[item.transactionID] === undefined) {
        this.editedRows = {
          ...this.editedRows,
          [item.transactionID]: item.disabled,
        }
      } else {
        this.editedRows = {
          ...this.editedRows,
          [item.transactionID]: !this.editedRows[item.transactionID],
        }
      }

      this.$store.commit('valuationEdit/addEdit', {
        categoryKey: 'offeredTransactions',
        edit: {
          [item.transactionID]: this.editedRows[item.transactionID],
        },
      })
    },
    changeCoefficient(item: any, value: string) {
      this.editedCoefficients = {
        ...this.editedCoefficients,
        [item.transactionID]: Number(value),
      }

      this.$store.commit('valuationEdit/addCoefficientEdit', {
        categoryKey: 'offeredTransactions',
        edit: {
          [item.transactionID]: this.editedCoefficients[item.transactionID],
        },
      })
    },
    isRowDisabled(item: any): boolean {
      if (this.editedRows[item.transactionID] === undefined) {
        return item.disabled
      }

      return !this.editedRows[item.transactionID]
    },
  },
})
